import { Link } from "react-router-dom";
import "./Error.css";

const Error = () => {
  return (
    <div className="error-page">
      <section className="error-container">
        <span>4</span>
        <span>
          <span className="screen-reader-text">0</span>
        </span>
        <span>4</span>
      </section>
      <div className="link-container">
        <Link className="error-link" to="/">
          <h3>HOME PAGE</h3>
        </Link>
      </div>
    </div>
  );
};

export default Error;
